import { render, staticRenderFns } from "./ReportByType.vue?vue&type=template&id=560cfe9a"
import script from "./ReportByType.vue?vue&type=script&lang=ts"
export * from "./ReportByType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports